import React, { useEffect, useState } from 'react';
import {
  CurrencyField,
  DataTable,
  DateTimeField,
  Field,
} from '../../commons/DataTable';
import { ContPaginationPage } from '../../styled-components';
import { CustomInput, FormGroup } from 'reactstrap';
import generatePaginationOptions from '../../lib/helpers/generatePaginationOptions';
import { useTranslation } from 'react-i18next';
import CommercialField from '../../commons/DataTable/CommercialField';

function InsurancesTabel({ data, total = 0 }) {
  const [t] = useTranslation('COMMON');

  const [insurances, setInsurances] = useState(data || []);
  const [query, setQuery] = useState({
    limit: 50,
    offset: 0,
  });

  const { limit, offset } = query;

  function onFilter(queryDiff) {
    if (queryDiff.limit && queryDiff.limit !== limit) {
      queryDiff.offset = 0; // return to first page
    }
    setQuery(queryDiff);
  }

  useEffect(() => {
    const paginatedInsurances = insurances.slice(offset, offset + limit);
    setInsurances(paginatedInsurances);
  }, [offset, limit]);

  return (
    <>
      <DataTable
        data={insurances}
        total={data.length}
        offset={offset}
        limit={limit}
        onFilter={onFilter}
        emptyText={t('NO_DATA')}
      >
        <Field title="Rami" source="branch" />

        <Field title="Codice polizza" source="policy_code" />
        <Field
          title="Nome Fornitore"
          source="supplier.businessName"
          className="text-left"
        />
        <Field title="Tipo agenzia" source="agencyType" className="text-left" />
        <CommercialField
          title="Posizione Commerciale"
          source="commercialPosition"
          className="txt-table-center"
        />
        <DateTimeField
          title="Data inizio"
          source="start_date"
          format="DD/MM/YYYY"
        />
        <DateTimeField
          title="Data fine"
          source="end_date"
          format="DD/MM/YYYY"
        />
        <CurrencyField
          title="Imponibile"
          source="net"
          className="txt-table-right"
        />
        <CurrencyField
          title="Quota commerciale"
          source="commercialShare"
          className="txt-table-right"
        />
      </DataTable>

      <ContPaginationPage>
        <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

        <FormGroup>
          <CustomInput
            type="select"
            className="pagination-select"
            id="perPage"
            name="perPage"
            value={query.limit}
            onChange={({ target: { value: limit } }) => {
              onFilter({ limit });
            }}
          >
            {generatePaginationOptions()}
          </CustomInput>
        </FormGroup>
      </ContPaginationPage>
    </>
  );
}

export default InsurancesTabel;
